import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param page
 * @param entityId
 * @param entityType
 * @param addressId
 * @param limit
 * @param tenantId
 * @param paymentId
 * @param payload
 */
class PaymentRequestServices {
  /**
   * @param {*} page
   * @param {*} limit
   * @param {*} tenantId
   * @param {*} paymentId
   * @param tenantSellerId
   * @return
   */
   getPaymentRequest = async (page, limit, tenantId) => {
     let url = `${Constants.PAYMENT_REQUEST}?`;
     if (tenantId) url += `tenant_id=${tenantId}&`;
     if (page) url += `page=${page}&`;
     if (limit) url += `limit=${limit}&`;
     const getPaymentRequest = await Helpers.get({
       url: `${url}`,
     });
     return getPaymentRequest;
   }

   /**
    *
    * @param payload
    * @return {Promise<*>}
    */
    createPaymentRequest = async (payload) => {
      const createPaymentRequest = await Helpers.post({
        url: Constants.PAYMENT_REQUEST,
        data: payload,
      });
      return createPaymentRequest;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
     updatePaymentRequest = async (payload) => {
       const updatePaymentRequest = await Helpers.put({
         url: Constants.PAYMENT_REQUEST,
         data: payload,
       });
       return updatePaymentRequest;
     }
}
export default new PaymentRequestServices();
